var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C31.6304 50 37.9893 47.3661 42.6777 42.6777C47.3661 37.9893 50 31.6304 50 25C50 18.3696 47.3661 12.0107 42.6777 7.32233C37.9893 2.63392 31.6304 0 25 0C18.3696 0 12.0107 2.63392 7.32233 7.32233C2.63392 12.0107 0 18.3696 0 25C0 31.6304 2.63392 37.9893 7.32233 42.6777C12.0107 47.3661 18.3696 50 25 50ZM21.0938 32.8125H23.4375V26.5625H21.0938C19.7949 26.5625 18.75 25.5176 18.75 24.2188C18.75 22.9199 19.7949 21.875 21.0938 21.875H25.7812C27.0801 21.875 28.125 22.9199 28.125 24.2188V32.8125H28.9062C30.2051 32.8125 31.25 33.8574 31.25 35.1562C31.25 36.4551 30.2051 37.5 28.9062 37.5H21.0938C19.7949 37.5 18.75 36.4551 18.75 35.1562C18.75 33.8574 19.7949 32.8125 21.0938 32.8125ZM25 12.5C25.8288 12.5 26.6237 12.8292 27.2097 13.4153C27.7958 14.0013 28.125 14.7962 28.125 15.625C28.125 16.4538 27.7958 17.2487 27.2097 17.8347C26.6237 18.4208 25.8288 18.75 25 18.75C24.1712 18.75 23.3763 18.4208 22.7903 17.8347C22.2042 17.2487 21.875 16.4538 21.875 15.625C21.875 14.7962 22.2042 14.0013 22.7903 13.4153C23.3763 12.8292 24.1712 12.5 25 12.5Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.eed62c8f6b9c5cf3c353edf38aeea997.svg";
export { ForwardRef as ReactComponent };